import { Suspense, lazy } from 'react'
import { Outlet, RouterProvider, ScrollRestoration, createBrowserRouter } from 'react-router-dom'
import { SiteFooter } from '@/components/site-footer'
import { SiteHeader } from '@/components/site-header'
import { ThemeProvider } from '@/components/theme-provider'
import { Spinner } from '@/components/ui/spinner'

const HomePage = lazy(() => import('@/pages/HomePage').then((module) => ({ default: module.HomePage })))
const CategoriesPage = lazy(() => import('@/pages/CategoriesPage').then((module) => ({ default: module.CategoriesPage })))
const CategoryPage = lazy(() => import('@/pages/CategoryPage').then((module) => ({ default: module.CategoryPage })))
const FavoritesPage = lazy(() => import('@/pages/FavoritesPage').then((module) => ({ default: module.FavoritesPage })))
const HelpPage = lazy(() => import('@/pages/HelpPage').then((module) => ({ default: module.HelpPage })))
const FredCategoryExplorerPage = lazy(() => import('@/pages/FredCategoryExplorerPage').then((module) => ({ default: module.FredCategoryExplorerPage })))
const IndicatorPage = lazy(() => import('@/pages/IndicatorPage').then((module) => ({ default: module.IndicatorPage })))
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })))
const RegionalPage = lazy(() => import('@/pages/RegionalPage').then((module) => ({ default: module.RegionalPage })))
const ReleasePage = lazy(() => import('@/pages/ReleasePage').then((module) => ({ default: module.ReleasePage })))
const ReleasesPage = lazy(() => import('@/pages/ReleasesPage').then((module) => ({ default: module.ReleasesPage })))
const SearchPage = lazy(() => import('@/pages/SearchPage').then((module) => ({ default: module.SearchPage })))
const SourcesPage = lazy(() => import('@/pages/SourcesPage').then((module) => ({ default: module.SourcesPage })))
const StocksPage = lazy(() => import('@/pages/StocksPage').then((module) => ({ default: module.StocksPage })))

function RouteFallback() {
  return (
    <div className="container flex min-h-[40vh] items-center justify-center py-10">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Spinner className="size-4" />
        正在加载页面...
      </div>
    </div>
  )
}

function RootLayout() {
  return (
    <ThemeProvider defaultTheme="dark" enableSystem disableTransitionOnChange>
      <div className="relative flex min-h-screen flex-col">
        <SiteHeader />
        <main className="flex-1">
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </main>
        <SiteFooter />
      </div>
      <ScrollRestoration />
    </ThemeProvider>
  )
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'categories',
        element: <CategoriesPage />,
      },
      {
        path: 'categories/fred',
        element: <FredCategoryExplorerPage />,
      },
      {
        path: 'categories/fred/:id',
        element: <FredCategoryExplorerPage />,
      },
      {
        path: 'categories/:id',
        element: <CategoryPage />,
      },
      {
        path: 'favorites',
        element: <FavoritesPage />,
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
      {
        path: 'indicator/:id',
        element: <IndicatorPage />,
      },
      {
        path: 'search',
        element: <SearchPage />,
      },
      {
        path: 'stocks',
        element: <StocksPage />,
      },
      {
        path: 'sources',
        element: <SourcesPage />,
      },
      {
        path: 'regional',
        element: <RegionalPage />,
      },
      {
        path: 'releases',
        element: <ReleasesPage />,
      },
      {
        path: 'releases/:id',
        element: <ReleasePage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])

export function App() {
  return <RouterProvider router={router} />
}
